import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { basicSavePerson } from '../../api/basicSavePerson';
import { getUUID } from '../../api/getUUID';
import Modal from 'react-bootstrap/Modal';
import foodbrand from '../../assets/foodbrand@2x.png';
import Pantalla1Pass from "../Pantalla1Pass/Pantalla1Pass";
import Header from '../../Header/Header';

function PantallaBase1Pass() {

    const navigate = useNavigate();
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState('');
    const [loading, setLoading] = useState(false);

    const getConfirmar = async () => {

        setLoading(true);

        const objModelIncode = {

            interviewId: localStorage.getItem("interviewIdPass"),
            tokenIncode: localStorage.getItem("tokenIncodePass"),
        }

        const responseModel = await getUUID(objModelIncode);

        if (responseModel.status === 200) {

            const objIncode = {
                identificationNumberId: localStorage.getItem("curpValidate"),
                interviewIdIne: localStorage.getItem("interviewIdPass"),
                tokenIncodeIne: localStorage.getItem("tokenIncodePass"),
                typeOfId: localStorage.getItem("typeOfId"),
                datosIneCompleto: true,
                cpv: localStorage.getItem("sCpv"),
                vigenciaCpv: localStorage.getItem("vigenciaCpv"),
                telefono: localStorage.getItem("telefono"),
                uuid: responseModel.uuid,
                nombre: localStorage.getItem("nombre"),
                paterno: localStorage.getItem("paterno"),
                materno: localStorage.getItem("materno"),
            }

            const response = await basicSavePerson(objIncode);

            if (response.status === 200) {

                localStorage.setItem('idPerson', '' + response.id);
                localStorage.setItem("uuid", "" + responseModel.uuid);
                localStorage.removeItem('interviewIdPass');
                localStorage.removeItem('tokenIncodePass');
                localStorage.removeItem('typeOfId');
                setLoading(false);
                navigate('/PantallaBase26');

            } else {

                setLoading(false);
                setShow(true);
                setShowStatus(response.status);
                setShowMessage(response.message);

            }

        } else {

            setLoading(false);
            setShow(true);
            setShowStatus(responseModel.status);
            setShowMessage(responseModel.message);

        }
    }

    const handleCloseError = async () => {
        setShow(false);
    }

    const getReintentar = async () => { navigate('/PantallaBase14') }

    return (
        <>
            <div className='initBack_P2 animate__animated animate__fadeIn'>

                <Header
                    imgBack={true}
                    rutaBack='/PantallaBase14'
                    title='Identificación Personal'
                    name='steepThree'
                />

                <div className="containerRender">
                    {loading ? (
                        <div className="spinner"></div>
                    ) : (
                        <div className="animate__animated animate__fadeIn">
                            <Pantalla1Pass />
                            <div className="footer">
                                <div className='containerCont_P2'>
                                    <button className='button_P2' onClick={getConfirmar} >
                                        <span className='txtButton_P2'>Confirmar</span>
                                    </button>
                                    <div className="spaceButton14" />
                                    <button className='buttonRein_P2' onClick={getReintentar} >
                                        <span className='txtButtonRein_P14'>Reintentar</span>
                                    </button>
                                </div>
                                <div className='imageContainer_P2'>
                                    <img src={foodbrand} className='imgFooter_P2' />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Modal show={show} onHide={handleCloseError} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleCloseError}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default PantallaBase1Pass
